import { Container, Row, Col } from "react-bootstrap";
import {
  VerticalFlex,
  HorizontalFlex,
  SpaceBetweenRow,
  Image,
  IconButton,
} from "../pandora/styled";
import Download from "resources/images/svg/download-file.svg";
import Downloadfiles from "resources/images/svg/sendFile.svg";
import Pdf from "resources/images/svg/pdf.svg";
import Dxf from "resources/images/svg/dxf.svg";
import { darkGreen, veryLightGrey } from "resources/newColors";
import { downloadFileClick } from "Utils/Utils";

export interface DisplayFilesProps {
  selectedUserFiles: string[] | undefined;
  setError: (b: boolean) => void;
  setErrorMessage: (s: string) => void;
}

export default function DisplayFiles({
  selectedUserFiles,
  setError,
  setErrorMessage,
}: Readonly<DisplayFilesProps>) {
  const downloadFiles = async (files: string[]) => {
    for (const file of files) {
      await new Promise<void>((resolve) => {
        if (file.indexOf(".pdf") > -1) {
          const link = document.createElement("a");
          link.href = file;
          link.download = file;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(file);
        } else {
          downloadFileClick(
            file,
            () => {
              setErrorMessage("Error While Requesting File!");
              setError(true);
            },
            true
          );
        }
        setTimeout(() => {
          resolve();
        }, 100);
      });
    }
  };
  function downloadtab(imagesrc: string, text: string, onclick: () => void) {
    return (
      <HorizontalFlex
        css={`
          border-top: 0px solid ${veryLightGrey};
        `}
        key={text + imagesrc}
      >
        <Row
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "30px",
          }}
        >
          <Col
            style={{
              fontWeight: "bold",
            }}
          >
            <SpaceBetweenRow
              css={`
                border: 0.5px solid ${darkGreen};
                padding: 10px;
              `}
            >
              <HorizontalFlex css="flex: 1">
                <Image width={"30px"} src={imagesrc} />
              </HorizontalFlex>
              <HorizontalFlex css="flex: 8">{text}</HorizontalFlex>
              <IconButton width={20} onClick={onclick} src={Download} />
            </SpaceBetweenRow>
          </Col>
        </Row>
      </HorizontalFlex>
    );
  }
  if (!selectedUserFiles?.length)
    return <HorizontalFlex css={"font-size: 11px;"}>Inga filer</HorizontalFlex>;
  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignSelf: "center",
      }}
      fluid
    >
      <VerticalFlex css="width: 100%; margin: 10px 0">
        {downloadtab(Downloadfiles, "Ladda ner alla filer", () =>
          downloadFiles(selectedUserFiles)
        )}
        {selectedUserFiles.map((item: string) =>
          downloadtab(
            item.includes("pdf") ? Pdf : Dxf,
            item.split("/").pop()?.split("?")[0],
            () => {
              if (item) {
                downloadFileClick(
                  item,
                  () => {
                    setErrorMessage("Error While Requesting File!");
                    setError(true);
                  },
                  true
                );
              } else {
                setError(true);
                setErrorMessage("File Not Found!");
              }
            }
          )
        )}
      </VerticalFlex>
    </Container>
  );
}
